"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _axios = _interopRequireDefault(require("axios"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

/**
 * Axios interceptor config to retry a request after getting a new access token.
 */
var _default = function _default(_ref) {
  var refreshToken = _ref.refreshToken;
  return {
    success: function success(res) {
      return res;
    },
    error: function () {
      var _error2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_error) {
        var config, token;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                config = _error.config;

                if (!(_error.response && _error.response.status === 401 // Authentication failed for original req
                && config.headers.Authorization // and it included an Authorization header
                && !config._retry // and we haven't already retried
                )) {
                  _context.next = 10;
                  break;
                }

                config._retry = true;
                _context.next = 5;
                return refreshToken();

              case 5:
                token = _context.sent;

                if (token) {
                  _context.next = 8;
                  break;
                }

                return _context.abrupt("return", Promise.reject(_error));

              case 8:
                config.headers.Authorization = "Bearer ".concat(token);
                return _context.abrupt("return", (0, _axios["default"])(config));

              case 10:
                return _context.abrupt("return", Promise.reject(_error));

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function error(_x) {
        return _error2.apply(this, arguments);
      }

      return error;
    }()
  };
};

exports["default"] = _default;